<template>
  <div class="flex">
    <div class="flex items-center justify-center flex-grow px-3 bg-white border-t border-b border-l rounded-l gap-x-2">
      <div class="relative grid w-2.5 h-2.5 place-items-center" v-if="!enabled">
        <div class="w-2.5 h-2.5 bg-red-500 rounded-full animate-pulse"></div>
      </div>
      <div class="relative grid w-2.5 h-2.5 place-items-center" v-else>
        <div class="w-2.5 h-2.5 bg-green-500 rounded-full"></div>
        <div class="absolute w-2.5 h-2.5 bg-green-500 rounded-full animate-ping top-0 left-0"></div>
      </div>
      <div class="text-sm font-medium -translate-y-px translate">
        {{ statusText }}
      </div>
    </div>
    <div>
      <button type="button" class="rounded-l-none btn btn-secondary btn-sm" @click="$emit('toggle')" :disabled="updating">
        {{ buttonText }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonToggle',

  props: {
    enabled: {
      type: Boolean,
      required: true
    },

    statusText: {
      type: String,
      required: true
    },

    buttonText: {
      type: String,
      required: true
    },

    updating: {
      type: Boolean
    }
  }
}
</script>
